import { useRef, useEffect } from 'react';
import throttle from 'raf-throttle';
import { isSSR } from './ssr';
var getScrollPosition = function () { return (isSSR ? 0 : window.pageYOffset); };
export var useScrollPosition = function (callback, deps) {
    if (deps === void 0) { deps = []; }
    var scrollPosition = useRef(getScrollPosition());
    useEffect(function () {
        if (isSSR)
            return;
        var handleScroll = throttle(function () {
            var updatedScrollPosition = getScrollPosition();
            callback({
                prevScrollPosition: scrollPosition.current,
                currScrollPosition: updatedScrollPosition
            });
            scrollPosition.current = updatedScrollPosition;
        });
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, deps);
};
